import axiosHttp from "../../services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardCategoryList = createAsyncThunk("fetchRewardCategoryList", async ({ identifier }) => {
	const response = await axiosHttp.get(`common/categories?keyword=${identifier}`);
	return response.data.data;
});

const rewardCategoryListSlice = createSlice({
	name: "rewardCategoryListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardCategoryList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardCategoryList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardCategoryList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default rewardCategoryListSlice.reducer;
